import React, { useEffect, useState } from "react";
import { withRouter, Link, useHistory, useLocation } from "react-router-dom";
import DataTableComponent from "../../../../../../../Util/DataTable/DataTable";
import Popup from 'reactjs-popup';
import "./../../../../Users/Users.css";
import { config, REGISTERED_THROUGH_CLEVELAND, REGISTERED_THROUGH_MULBERRY } from "../../../../../../../config";
import logo1 from "../../../../../../../assets/table-img.svg"
import logo2 from "../../../../../../../assets/table-img2.svg"
import { formatPhoneNumber, maskingToPlainNumber, WARNING_DIALOG_TYPE } from "../../../../../../../Util/helper";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { useParams } from 'react-router-dom';
import AddPlayerModel from "./Models/AddPlayerModel";
import WarningDialogue from '../../../../../../../Util/WarningDialogue';
import { messages } from "../../../../../../../messages";
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './AddPlayer.css';
import backArrow from "../../../../../../../assets/arrow-back.svg";
const columns = [
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Player</div>,
    selector: () => 'first_name',
    className: 'left-align',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : 'N/A'}{row.registered_through === 'C' ? <img src={logo1} alt='logo' /> : <img className="icon" src={logo2} alt='logo' />}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Email</div>,
    selector: () => 'email',
    minWidth: '160px !important',
    sortable: 'true',
    style: {
      padding: '0',
      whiteSpace: 'pre-wrap !important'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.email ? row.email : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Primary Phone</div>,
    selector: () => 'cell_phone',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.cell_phone ? formatPhoneNumber(row.cell_phone) : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Secondary Phone</div>,
    selector: () => 'secondary_phone',
    minWidth: '136px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.secondary_phone ? formatPhoneNumber(row.secondary_phone) : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Shirt Size</div>,
    selector: () => 'shirt_size',
    minWidth: '98px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.shirt_size ? row.shirt_size : 'N/A'}</div>)
  },
];

const userType = 'user';


function AddPlayer(props) {
  const history = useHistory();
  const teamId = useParams().id;
  const leagueId = useParams().league_id;
  const teamName = 'test';
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [userDetail, setUserDtail] = useState({
    first_name: '',
    last_name: '',
    cell_phone: '',
    email: '',
    direction: 'desc',
    sort_column: '',
    page: 1,
    limit: 50,
    user_type: userType,
    team_id: teamId,
    registered_through: '',
  });
  const [totalPage, setTotalPage] = useState(0);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const [isPlayerCaptain, setIsPlayerCaptain] = useState(false);
  const [playerId, setPlayerId] = useState(0);
  const [playerRegistration, setPlayerRegistration] = useState({});
  const closeModal = () => {
    setOpen(false);
  }
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');

  const getUsers = () => {
    axiosApi.get(`${config.apiUrl}/misc/users/`, {
      params: userDetail
    })
      .then((response) => {
        setUserData(response.data.data);
        setTotalPage(response.data.total);
      })
  }


  useEffect(() => {
    getUsers();
  }, [userDetail.page, userDetail.limit, userDetail.direction, userDetail.sort_column])

  const getTeamInfo = () => {
    axiosApi.get(`${config.apiUrl}/teams/${teamId}`)
      .then((response) => {
        if (response.data.data && response.data.data.imported_from)
          if (response.data?.data?.league?.hosted_by) {
            setUserDtail((prevValue) => (
              {
                ...prevValue,
                'registered_through': response.data.data.league.hosted_by === 'mulberry' ?
                  REGISTERED_THROUGH_MULBERRY :
                  REGISTERED_THROUGH_CLEVELAND,
              }
            ));
          }
      })
  }

  useEffect(() => {
    if (teamId) {
      getTeamInfo();
    }
    //eslint-disable-next-line
  }, [])

  const handleChange = (e) => {
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.name === 'cell_phone' ? maskingToPlainNumber(e.target.value.trim()) : e.target.name === 'page' ? e.target.value : e.target.value.trim(),
      })
    }
    setUserDtail(stateFunc);
  }
  const handleSearch = (e) => {
    e.preventDefault();
    setUserDtail(() => ({
      ...userDetail,
      'page': 1,
      'limit': 50,
      'direction': 'desc',
      'sort_column': '',
    }))
    getUsers();
  }
  const addPlayer = (data) => {
    const userId = data.id;
    setPlayerId(userId);
    setOpenWarningPopup(true);
    data.allIndividualRegistration = data?.allIndividualRegistration.length > 0 ? data?.allIndividualRegistration.filter(x => x.league?.name) : [];
    if (data?.allIndividualRegistration.length > 1) {
      const leagueList = data?.allIndividualRegistration.map(x => ({...x, league_name: x.league.name}));
      setPopUpContent({
        header: messages.addPlayerTitle,
        description: messages.addPlayer,
        icon: faExclamationTriangle,
        leagues: leagueList,
      });
    } else {
      setPlayerRegistration(data?.allIndividualRegistration.length ? data?.allIndividualRegistration[0]: {});
      setPopUpContent({
        header: messages.addPlayerTitle,
        description: messages.addPlayer,
        icon: faExclamationTriangle,
      });
    }
    
  }

  /** Add as captain checkbox callback method */
  const handleCaptainChange = (cb) => {
    setIsPlayerCaptain(cb);
  }
  
  /** Add as captain method */
  const addAsCaptain = () => {
    axiosApi.post(`${config.apiUrl}/teams/associate/player`, {
      user_id: playerId,
      team_id: teamId,
      league_id: leagueId,
      imported_from: userDetail.registered_through,
      is_captain: isPlayerCaptain,
      playerRegistration,
    })
      .then((response) => {
        setOpenWarningPopup(false);
        history.push(props.from ? `/admin/leagues/individual-registrations/TeamInfo/${leagueId}/${teamId}` : `/admin/leagues/LeagueGroups/TeamInfo/${leagueId}/${teamId}`);
      })
      .catch((err) => {
        getUsers();
        setOpenWarningPopup(false);
      })
  }

  const onLeagueSelect = (data) => {
    setPlayerRegistration(data);
  }

  const onCheckChange = (e) => {
    setPlayerRegistration((prev) => ({...prev, send_email_link: e.target.checked}));
  }
  return (
    <>

      <div className="content-wrapper users-wrapper addPlayer-wrapper">
        <div className="heading-wrapper">
          <Link to={props.from ? `/admin/leagues/individual-registrations/TeamInfo/${leagueId}/${teamId}` : `/admin/leagues/LeagueGroups/TeamInfo/${leagueId}/${teamId}${season_id ? `?season_id=${season_id}` : ''}`}><button className="primary-btn back-btn"><img src={backArrow} alt="" />Back to Team</button></Link>
          <h1 className="heading">Add Player to {teamName}</h1>
          <p>Manually add a player or search for a registered user.</p>
          <button className="btn" onClick={() => setOpen(o => !o)}>Add Manually</button>
        </div>
        <div className="search-blk">
          <h2>Search</h2>
          <form onSubmit={handleSearch}>
            <div className="input-field">
              <label htmlFor="first_name">First Name</label>
              <input type="text" id="first_name" name="first_name" onChange={handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="last_name">Last Name</label>
              <input type="text" id="last_name" name="last_name" onChange={handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="email">Email Address</label>
              <input type="text" id="email" name="email" onChange={handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="contact">Phone Number</label>
              <input id="cellPhone" name="cell_phone" onChange={handleChange} />
            </div>
            <button type='submit'>Search</button>
          </form>
        </div>
        <div className="table-wrapper">
          <div className="heading-blk">
            <div className="left">
              <h2>Results</h2>
              <p>Select a user to add to team.</p>
            </div>
          </div>
          <div className="dataTable">
            <DataTableComponent key="table-admin-users"
              type={'addPlayer'}
              data={userData}
              columns={columns}
              onFilterChange={handleChange}
              totalPage={totalPage}
              addPlayer={(data) => { addPlayer(data) }} />
          </div>
        </div>
      </div>
      <Popup className="overflow-container" open={open} closeOnDocumentClick={false} onClose={closeModal}>
        {<AddPlayerModel closeModal={closeModal} teamId={teamId} leagueId={leagueId} teamName={teamName} fromLeague={!props.from} seasonId={season_id}
        />}
      </Popup>
      <WarningDialogue
        type={WARNING_DIALOG_TYPE.ADD_PLAYER}
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={addAsCaptain}
        onClose={() => {setOpenWarningPopup(false); setPlayerRegistration({}) }}
        isCaptain={handleCaptainChange}
        leagueSelect={popUpContent.leagues}
        selectedLeague={playerRegistration}
        onLeagueSelect={onLeagueSelect}
        onCheckChange={onCheckChange}
      />
    </>
  );
}

export default withRouter(AddPlayer);
